import {gaConfig} from '@stencil/hotels-config';
import {defaultTheme} from '@stencil/build-theme';
// SELECTORS FNS
import {goStaysSelector as goStaysSelectorFn} from '@stencil/hotels-details-reducer/src/selectors';
// import {pushga} from 'ga-utils/src/ga-utils';
import detailsPageClickGaPush from '@stencil/hotels-utils/src/details-page-click-ga-push';
import React from 'react';
// HOOKS
import {useSelector} from 'react-redux';
import {createSelector} from 'reselect';
// COMPONENTS
import {HoverTargetWrapperDiv} from '../../../../../../stories/components/hotels/SRP/AmenitiesList/AmenitiesList.styles';
import ShieldIcon from '../../../../../../stories/Icons/ShieldIcon';
// STYLES
import * as S from './GoStaysStamp.styles';

import GostaysIcon from '../../../../../../stories/Icons/Gostays';

const {DetailsGAClickEventActions} = gaConfig;

const goStaysLogoBooleanSelector = createSelector([goStaysSelectorFn], isGoStays => {
  return {
    isGoStays,
  };
});

const GoStaysStamp: React.FC<{
  gostaysHoverList: string[];
}> = ({gostaysHoverList}) => {
  const {isGoStays} = useSelector(goStaysLogoBooleanSelector);

  if (isGoStays) {
    return (
      <HoverTargetWrapperDiv>
        <S.CertifiedLabel>
          <S.GostaysIconComponent />
          <S.CertifiedText>CERTIFIED</S.CertifiedText>
          <S.ArrowDown />
          <S.LeftFacingUIIntentArrow />
        </S.CertifiedLabel>

        <S.GostaysHoverHiddenDropdown>
          <S.TipPositioning />
          <S.CertifiedLabelHoverContainer>
            <S.GostaysIconCertified>
              <GostaysIcon
                width="4.6rem"
                height="4.6rem"
                fill={defaultTheme.colors.goBrandOrange.base}
              />
            </S.GostaysIconCertified>
            <S.CertifiedDetailsListWrap>
              {!!gostaysHoverList &&
                gostaysHoverList.map((item: string) => (
                  // <S.CertifiedGoStayWrap key={item}>

                  <li key={item}>
                    <ShieldIcon fill="white" />
                    <span>{item}</span>
                  </li>
                  // </S.CertifiedGoStayWrap>
                ))}

              <S.ShowMoreLink
                href="https://www.goibibo.com/info/gostays-mbg-new/  "
                target="_blank"
                rel="noopener"
                onClick={() => {
                  detailsPageClickGaPush({
                    eventAction: DetailsGAClickEventActions.gostaysKnowMoreClick,
                  });
                }}
              >
                Know More
              </S.ShowMoreLink>
            </S.CertifiedDetailsListWrap>
          </S.CertifiedLabelHoverContainer>
        </S.GostaysHoverHiddenDropdown>
      </HoverTargetWrapperDiv>
    );
  }

  return null;
};

export default GoStaysStamp;
